import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

const LoadingPopup = ({ onComplete }) => {
  const [secondsLeft, setSecondsLeft] = useState(10);

  useEffect(() => {
    if (secondsLeft <= 0) {
      onComplete();
      return;
    }
    const timer = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000);
    return () => clearTimeout(timer);
  }, [secondsLeft, onComplete]);

  return (
    <div className="flex flex-col items-center space-y-4">
      <Loader2 className="animate-spin w-8 h-8 text-blue-500" />
      <p className="text-gray-700">Processing your report... {secondsLeft}s</p>
      <div className="w-full h-2 bg-gray-200 rounded">
        <div
          className="h-2 bg-blue-600 rounded"
          style={{ width: `${(10 - secondsLeft) * 10}%` }}
        ></div>
      </div>
    </div>
  );
};

export default LoadingPopup;
